import React from 'react';
// prettier-ignore
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { buttonsTheme } from './_theme.jsx';

export const CopyAlert = ({ open, handleClose, title }) => {
    return (
        <ThemeProvider theme={buttonsTheme} style={{ width: '50%' }}>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className={'flex-column-container'}>
                        <IconButton
                            aria-label="success"
                            sx={{ color: '#F19001', transform: 'scale(4)', marginBottom: '3vh' }}
                            size="large"
                        >
                            <CheckCircleIcon />
                        </IconButton>
                        <div style={{ color: 'rgb(246,136,53)', fontSize: '2rem', marginBottom: '3vh' }}>Success!</div>
                        <div style={{ fontSize: '1rem', color: 'rgb(91,99,102)' }}>{title} copied to clipboard</div>
                    </div>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button variant="contained" color="primary" sx={{ marginBottom: '2vh' }} onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};
